import { useState } from "react";


const AddToCartContent = ({ product, onAddToCart, onClose }) => {
  const [size, setSize] = useState("");
  const [error, setError] = useState("");

  return (
    <div className="grid md:grid-cols-2 gap-6">

      <img
        src={product.image}
        alt={product.name}
        className="w-full h-72 object-cover rounded-lg"
      />

      <div>
        <h2 className="text-2xl font-semibold">{product.name}</h2>
        <p className="mt-3 font-bold text-xl">₹{product.price}</p>

        <div className="mt-5">
          <p className="font-semibold mb-2 uppercase text-sm">
            Select Size
          </p>

          <div className="flex gap-3 flex-wrap">
            {["S", "M", "L", "XL"].map((s) => (
              <button
                key={s}
                onClick={() => {
                  setSize(s);
                  setError("");
                }}
                className={`border px-4 py-2 rounded-md transition ${
                  size === s ? "bg-black text-white" : "hover:bg-gray-100"
                }`}
              >
                {s}
              </button>
            ))}
          </div>

          {error && (
            <p className="text-red-500 mt-2 text-sm">
              Please select the size
            </p>
          )}
        </div>

        <button
          onClick={() => {
            if (!size) {
              setError(true);
              return;
            }
            onAddToCart(product, size);
            onClose();
          }}
          className="mt-6 w-full bg-black text-white py-3 rounded-lg hover:bg-gray-900 transition"
        >
          DONE
        </button>
      </div>
    </div>
  );
};

export default AddToCartContent